import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  gs,
  ls,
  f,
  BtnC,
  BtnTopC,
  TblC,
  TextC,
} from 'lib';
*/
import * as TextC from "./_ccbTextC";
import * as BtnC from "./_cccBtnC";
import * as BtnTopC from "./_ccmBtnTopC";
import * as TblC from "./_ccmTblC";
import * as _cm from './_cm';
import * as _cmFTH from './_cmFTH';
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';

import * as ica from 'src/ica';

import * as ihdI11 from './ihdI11';

//import * as icvi11 from './icvI11___Mz'; 

let $i11rs = [] as ht.ls;

export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
      }
    })
  )
};

export const L = (pz: ht.viewListCz) => {

  const _gUserz = gs.useUserz();
  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {
    if (_gUserz.crt._dmn > 0) {
//      icvi11.loadI11rLsAsync({
//        _31r_fst: _gUserz.crt._31rz._fst,
//        //lwrType: 1,
//      })
//      .then( (_ls: ht.ls) => {
//        $i11rs = _ls;
//        _frcUdt();
//      })
      (async () => {
//        $i11rs = await icvi11.loadI11rLsAsync({
//          _31r_fst: _gUserz.crt._31rz._fst,
//        });
        $i11rs = await _cmFTH.loadLsAsync(ihdI11.grtQryLoadI11rLsAsync(_cm.grtUz(), {
          _31r_fst: _gUserz.crt._31rz._fst,
        }));
        _frcUdt();
      })();
    }
  }, [
    _gUserz.crt._dmn,
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;
  const _cellCs = [
    {
      boxStlz: a('f/0.25'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: 'ID',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '時間帯区分名'
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.25'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  const _rows = [] as ht.ls;
  $i11rs.map( ( i11rz: ht.dz ) => {
    const _cellCs = [
      {
      boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: i11rz._icn,
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: i11rz._pfx
            }
          })
        ]
      },
      {
      boxStlz: a('f/0.25'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            lblCz: {
            },
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  i11r_fst: i11rz._fst,
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/60'),
        },
      },
      hdrCz: {
        lineCs: _hdrs,
      },
      bdyCz: {
        lineCs: _rows,
      },
    })
  );
};
